/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoWalletTransferCreate } from '../../models/dto-wallet-transfer-create';
import { WalletTransferItem } from '../../models/wallet-transfer-item';

export interface BookingControllerCreateWalletTransfer$Params {
      body: DtoWalletTransferCreate
}

export function bookingControllerCreateWalletTransfer(http: HttpClient, rootUrl: string, params: BookingControllerCreateWalletTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransferItem;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerCreateWalletTransfer.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WalletTransferItem;
      }>;
    })
  );
}

bookingControllerCreateWalletTransfer.PATH = '/booking/wallet/transfer';
